export enum OAuth2OidcPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
